/** ADMIN 来源资格输入/响应：客户端仅声明起点或触发核验，不能提交资格与证据。 */
import { z } from 'zod';
const digest = z.string().regex(/^[a-f0-9]{64}$/);
const evidenceCheck = z
  .object({ passed: z.boolean(), evidence_digest: z.string().min(1).max(256) })
  .strict();
export const UsdQualificationEvidenceSchema = z
  .object({
    source: z.enum(['NATIVE_ADAPTY', 'WEB_STRIPE']),
    covered_since: z.string().date(),
    checked_until: z.string().datetime({ offset: true }),
    source_config_fingerprint: digest,
    checks: z
      .object({
        source_configuration: evidenceCheck,
        read_permissions: evidenceCheck,
        history_completeness: evidenceCheck,
      })
      .strict(),
    evidence_digest: digest,
    captured_at: z.string().datetime({ offset: true }),
  })
  .strict();
export const DeclareUsdCoverageRequestSchema = z
  .object({ covered_since: z.string().date() })
  .strict();
export const EmptyUsdCoverageRequestSchema = z.object({}).strict();
export const ListUsdCoverageQuerySchema = z
  .object({
    app_id: z.string().uuid().optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
  })
  .strict();
export const UsdCoverageResponseSchema = z
  .object({
    app_id: z.string().uuid(),
    covered_since: z.string().date(),
    verified_at: z.string().datetime({ offset: true }).nullable(),
    verified_by: z.string(),
    declared_by: z.string().uuid().nullable(),
    qualification_evidence: UsdQualificationEvidenceSchema.nullable(),
    created_at: z.string().datetime({ offset: true }),
    updated_at: z.string().datetime({ offset: true }),
    deleted_at: z.string().datetime({ offset: true }).nullable(),
  })
  .strict();
export type UsdCoverageResponse = z.infer<typeof UsdCoverageResponseSchema>;
export type UsdQualificationEvidence = z.infer<typeof UsdQualificationEvidenceSchema>;
